import { HttpClient } from "../HttpClient";

export const PostBulkArchive = async (ids) => {
  try {
    const { data } = await HttpClient.post(`api/Application/BulkArchive`, ids);
    return data;
  } catch (err) {
    console.error("Error archiving applications:", err);
    return null;
  }
};
